/**
 * @file コンポーネント フル動画ページお気に入りボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnHandleApiErrors } from "~/src/functions/common";

// コンポーネントを返す
export const ButtonFavorite = (props) => {
    /**
     * お気に入りボタンクリック時の処理
     */
    const fnOnClickButton = async () => {
        const api = "/api/Favorites/change";
        const token = document
            .getElementById("requestverificationtoken")
            .getAttribute("value");
        const options = {
            body: JSON.stringify({
                isFavorite: !props.isFavorite,
                operationId: window.atob(props.operationId),
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: token,
            },
            method: "POST",
        };
        fetch(api, options)
            .then(fnHandleApiErrors)
            .then((response) => {
                // 成功時にお気に入り状態を変更
                if (response.status === 200) {
                    props.setIsFavorite(!props.isFavorite);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnClickButton={fnOnClickButton} />;
};
